import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import LogoFallback from "/assets/img/bubbanlogo.jpg";

export default function AdmIns({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Admission Instruction | Bandarban University",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-700 to-teal-700 text-white py-20 text-center">
        <motion.h1
          className="text-4xl md:text-6xl font-bold tracking-wide mb-4"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Admission Circular 
        </motion.h1>
        <motion.p
          className="text-lg max-w-3xl mx-auto opacity-90"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          Bandarban University, Bangladesh  
          Apply Online <span className="font-semibold"></span>
        </motion.p>
        <a
          href="https://web.bubban.ac.bd/home/apply-online"
          target="_blank"
          rel="noreferrer"
          className="mt-8 inline-block bg-white text-indigo-700 font-semibold px-6 py-3 rounded-lg shadow hover:bg-gray-100 transition"
        >
          Apply Online
        </a>
      </section>

      <div className="max-w-6xl mx-auto px-6 py-12 space-y-12">
       
       
        {/* Eligible Programs */}
        <div>
          <h2 className="text-2xl font-bold text-indigo-700 mb-4">
            Programs Offered
          </h2>
          <p className="text-gray-700 mb-2">
            CSE, BBA, GDS, English, HTM, MBA
          </p>
        </div>


        {/* Admission Test Subjects */}
        <div>
          <h2 className="text-2xl font-bold text-teal-700 mb-4">
            Admission Test Marks Distribution
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full border rounded-lg shadow overflow-hidden">
              <thead className="bg-teal-700 text-white">
                <tr>
                  <th className="p-3 text-left">Program</th>
                  <th className="p-3 text-left">Subjects</th>
                  <th className="p-3 text-left">Marks</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200 text-gray-700">
                <tr>
                  <td className="p-3">Engineering</td>
                  <td className="p-3">Physics, Chemistry, Math, English, Aptitude, Viva</td>
                  <td className="p-3"></td>
                </tr>
                <tr>
                  <td className="p-3">BBA, GDS & HTM</td>
                  <td className="p-3">Math/Economics, English, GK, Viva</td>
                  <td className="p-3"></td>
                </tr>
                <tr>
                  <td className="p-3">English</td>
                  <td className="p-3">English, GK, Viva</td>
                  <td className="p-3"></td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>

        {/* Application Process */}
        <div>
          <h2 className="text-2xl font-bold text-indigo-700 mb-4">
            Application Process
          </h2>
          <ol className="list-decimal ml-6 space-y-2 text-gray-700">
            <li>
              Apply online via{" "}
              <a
                href="https://web.bubban.ac.bd/home/apply-online"
                className="text-indigo-600 font-semibold hover:underline"
              >
                bubban.ac.bd
              </a>
            </li>
            <li>Upload photo (250×300px) & signature (250×80px)</li>
            <li>Pay Tk. 1000 via bKash (01XXXXXXXXXX) or BUBBAN Accounts Office</li>
            <li>Download Admit Card & Admission Form after submission</li>
          </ol>
        </div>

        {/* Contact */}
        <div className="bg-green-700 text-white rounded-xl p-6 shadow-lg">
          <h3 className="text-xl font-semibold mb-2">Admission Helpline</h3>
          <p>📞 +8801318305900, +8801318305899</p>
		  <p>✉️ admission@bubban.ac.bd</p>
          <a
            href="https://www.bubban.ac.bd/admission-advertisements"
            target="_blank"
            rel="noreferrer"
            className="mt-4 inline-block bg-white text-indigo-700 px-5 py-2 rounded-lg shadow hover:bg-gray-100"
          >
            View Full Circular
          </a>
        </div>
      </div>
    </div>
  );
}
